import {css} from '@emotion/react'
import QrLink from './QrLink'
import AppleIcon from '../../../images/app/AppleIcon.svg'
import AndroidIcon from '../../../images/vanish/icons/android-icon.svg'

const translations = {
    en: {
        downloadCta: 'Download',
        supportedOs: 'For iPhone & Android',
        qrCodeInstructions: 'Scan QR code with your phone to get the app.',
    },
    fr: {
        downloadCta: 'Télécharger',
        supportedOs: 'Pour iPhone et Android',
        qrCodeInstructions: 'Scannez le code QR avec votre téléphone pour obtenir l’app.',
    },
    de: {
        downloadCta: 'Herunterladen',
        supportedOs: 'Für iPhone & Android',
        qrCodeInstructions: 'Scannen Sie den QR-Code mit Ihrem Telefon, um die App zu erhalten.',
    },
    nl: {
        downloadCta: 'Downloaden',
        supportedOs: 'Voor iPhone & Android',
        qrCodeInstructions: 'Scan de QR-code met uw telefoon om de app te krijgen.',
    },
}
const DownloadBadge = ({languageCode = 'en', overrideStyles}) => {
    const text = translations[languageCode] || translations.en
    return (
        <div
            className="download-buttons"
            css={css`
                display: flex;
                align-items: center;
                gap: 20px;
                border-radius: 30px;
                background: rgba(16, 0, 38, 0.4);
                padding: 24px 30px;
                width: fit-content;
                ${overrideStyles}
                @media (max-width: 640px) {
                    flex-direction: row;
                    flex-wrap: wrap;
                }
                @media (max-width: 395px) {
                    flex-direction: column;
                    gap: 10px;
                }
            `}
        >
            <div
                css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    @media (max-width: 395px) {
                        gap: 2px;
                    }
                `}
            >
                <h2
                    className="download-cta"
                    css={css`
                        color: var(--text-secondary, #b4a8e1);
                        leading-trim: both;
                        text-edge: cap;
                        font-family: Inter;
                        font-size: 34px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 30px; /* 88.235% */
                        letter-spacing: 0.34px;
                        @media (max-width: 460px) {
                            font-size: 24px;
                            line-height: 28px;
                            text-align: center;
                        }
                    `}
                >
                    {text.downloadCta}
                    <span
                        css={css`
                            color: inherit;
                            @media (max-width: 395px) {
                                display: none;
                            }
                        `}
                    >
                        &nbsp;→
                    </span>
                </h2>
                <div
                    className="os-container"
                    css={css`
                        display: flex;
                        align-items: center;
                        gap: 12px;
                    `}
                >
                    <p
                        css={css`
                            color: var(--text-primary, #f2f3fb);
                            leading-trim: both;
                            text-edge: cap;
                            font-family: Inter;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 20px; /* 142.857% */
                        `}
                    >
                        {text.supportedOs}
                    </p>
                    <div
                        className="os-icons-container"
                        css={css`
                            display: flex;
                            align-items: center;
                            gap: 4px;
                            .os-icon-container {
                                width: 24px;
                                height: 24px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                border-radius: 36.75px;
                                background: var(--background-teritary, #100026);
                            }
                            @media (max-width: 460px) {
                                display: none;
                            }
                        `}
                    >
                        <div className="os-icon-container">
                            <AppleIcon
                                css={css`
                                    width: 14px;
                                    height: 14px;
                                    path {
                                        fill: #f2f3fb;
                                    }
                                `}
                            />
                        </div>
                        <div className="os-icon-container">
                            <AndroidIcon
                                css={css`
                                    width: 14px;
                                    height: 14px;
                                    path {
                                        fill: #f2f3fb;
                                    }
                                `}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <QrLink />
            </div>
            <p
                css={css`
                    width: 115px;
                    color: var(--whisper-dark, #ebecf7);
                    leading-trim: both;
                    text-edge: cap;
                    font-family: Inter;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px; /* 142.857% */
                    letter-spacing: 0.07px;
                    @media (max-width: 600px) {
                        display: none;
                    }
                `}
            >
                {text.qrCodeInstructions}
            </p>
        </div>
    )
}

export default DownloadBadge
